export default {
  EMPLOYEE: 'EMPLOYEE',
  RELINK: 'RELINK',
  UNEMPLOYED: 'UNEMPLOYED',
  COMPANY: 'COMPANY',
  PUBLIC: 'PUBLIC',
  ADMIN_UNEMPLOYED: 'ADMIN_UNEMPLOYED',
}
